import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import HistoryContent from 'components/history/HistoryContent';
import useParkingHistoryFilter from 'hooks/useParkingHistoryFilter';
import useReadPurchasedPrepaidTickets from 'hooks/useReadPurchasedPrepaidTickets';
import useReadReceipts from 'hooks/useReadReceipts';
import { concat } from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ParkingSession, Receipt } from 'types/generatedSchemaTypes';
import { AccountStackParamList } from 'types/navigation';
import { permitTypes, prepaidTypes } from 'utils/parkUtils';

const PrepaidHistoryScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const { params } =
    useRoute<RouteProp<AccountStackParamList, 'prepaidHistory'>>();
  const isSubscription = params?.isSubscription ?? false;
  const { parkingType, filter, setFilter } = useParkingHistoryFilter();
  const { prepaidTicketsWithCorporateAccount } = useReadPurchasedPrepaidTickets(
    {
      fetchAll: true,
    }
  );

  const {
    data: receiptData,
    loading: loading,
    error: receiptDataError,
    fetchMoreCallback,
    resetPage,
  } = useReadReceipts(
    isSubscription ? ['AIMO_PLUS'] : concat(permitTypes, prepaidTypes)
  );

  useEffect(() => {
    if (isSubscription) {
      navigation.setOptions({
        title: t('account.aimoSubscription.title'),
        headerRight: undefined,
      });
    }
  }, [isSubscription, navigation, t]);

  useEffect(() => {
    resetPage();
  }, []);

  useEffect(() => {
    if (!isSubscription && parkingType !== undefined) {
      setFilter({ ...filter, parkingType: undefined });
    }
  }, [parkingType, filter, isSubscription, setFilter]);

  if (receiptDataError) {
    return <></>;
  }

  return (
    <HistoryContent
      fetchMore={fetchMoreCallback}
      prepaidSessions={prepaidTicketsWithCorporateAccount as ParkingSession[]}
      loading={loading}
      isLast={receiptData?.last || false}
      receiptData={(receiptData?.content || []) as Receipt[]}
      historyScreenName={isSubscription ? 'SUBSCRIPTION' : 'PREPAID_AND_PERMIT'}
    />
  );
};

export default PrepaidHistoryScreen;
